import styled from 'styled-components'
export default styled.div`
  display: inline-block;
  vertical-align: top;
  width: 100%;
  @media (max-width: 986px) {
    width: auto;
    &.ll-classification {
      margin-top: 15px;
    }
    margin: 0 auto;
    display: block;
  }
`
